// 公共
const COMMON = {
  LOCALMODULE: '/local/module',
  COURSE: '/course',
  COURSERECOMMEND: '/course/recommend',
  LOGIN: '/auth/login',
  COURSEDETAILS: '/course/coursedetails',
  CERTSEARCH: '/cert/search',
  GETENTERPRISEREGISTRATION: '/enterprise/registration',
  EMPLOYEEDEGREE: '/common/employeedegree',
  EMPLOYEETITLE: '/common/employeetitle',
  CERTCLASS: '/common/certclass',
  CERTSUBCLASS: '/common/certsubclass',
  COURSEOPENJOBS: '/course/openjobs',
  JOB: '/course/job',
  LEARNLEARNDETAILS: 'learn/learndetails',
  LEARNLEARNAPPROVESTEP: 'learn/learnapprovestep',
  COMMONLEARNPAYMETHOD: '/common/learnpaymethod',
  COMMONMAKEUPPAYMETHOD: '/common/makeuppaymethod',
  SENDVERIFYCODE: '/sendverifycode',
  NEWS: '/news',
  NEWSDETAILS: '/news/details',
  NEWSTESTPLANS: '/newstestplans',
  SENDCHANGEPWDVERIFYCODE: '/sendchangepwdverifycode',
  CHANGEPASSWORD: '/changepassword',
  LEARNINGMGTDETAILS: 'learningmgtdetails',
  MAKEUPMAKEUPDETAILS: '/makeup/makeupdetails',
  MAKEUPMAKEUPAPPROVESTEP: 'makeup/makeupapprovestep',
  VERIFYTCAPTCHATICKET: 'verifytcaptchaticket',
  COMMONJOB: 'common/job',
  COMMONUPLOADPIC: '/common/uploadpic',
  COMMONUPLOADFILE: '/common/uploadfile',
  STUDYRECORDDETAILS: '/study/recorddetails',
  COMMONINVOICETYPES: '/common/invoicetypes',
  COMMONINVOICEPAYBODYS: '/common/invoicepaybodys',

  INVOICEAPPROVEADETAILS: 'invoiceapprove/details',

  COMMONQUICKCOMMENTS: 'common/quickcomments',

  WEIXINTMPQRCODE: '/weixin/tmpqrcode'
};

// 本地
const LOCAL = {
  ENROLLSTUDENT: '/local/enrollstudent',
  ENROLL: '/local/enroll'
};

// 企业
const QYGL = {
  ENTERPRISEEMPLOYEE: '/employee/enterpriseemployee',
  ROOT: '/employee',
  LEARNADDEMPLOYEES: '/learn/addemployees',
  LEARNREGISTRATION: '/learn/registration',
  LEARNSAVE: '/learn/save',
  LEARNCANCEL: '/learn/cancel',
  LEARNWEIXINPAYCODE: '/learn/weixinpaycode',
  LEARNWEIXINPAYRESULT: '/learn/weixinpayresult',
  LEARNENTERPRISELEARN: '/learn/enterpriselearn',
  LEARNINGMGTQY: 'learningmgt/qy',
  EMPLOYEECOMMITMENTLETTER: 'learn/employeecommitmentletter',
  MAKEUPLEARNDETAILS: '/makeup/makeuplearndetails',
  MAKEUPREGISTRATION: '/makeup/registration',
  MAKEUPENTERPRISEMAKEUP: '/makeup/enterprisemakeup',
  MAKEUPUPDATEJFPZ: '/makeup/updatejfpz',
  ENTERPRISEMYENTERPRISE: '/enterprise/myenterprise',
  LEARNUPDATEJFPZ: 'learn/updatejfpz',
  LEARNUPDATEEMPLOYEEPIC: 'learn/updateemployeepic',
  LEARNUPDATECCONTRACT: 'learn/updateccontract',
  LEARNAYMENTINFOSAVE: 'learn/paymentinfo/save',
  LEARNPAYMENTINFOSUBMIT: 'learn/paymentinfo/submit',
  CMTYPE: 'cmtype',
  CMJOB: 'cmjob',
  ALLCMJOB: 'allcmjob',
  CMCERTIFICATE: 'cmcertificate',
  CMCERTIFICATEDETAILS: 'cmcertificate/details',
  CMCERTIFICATEQY: 'cmcertificate/qy',
  CMCERTIFICATEIMPORT: 'cmcertificate/import',
  CMCERTIFICATEREMOTESEARCH: 'cmcertificate/remotesearch',
  CMEMPLOYEE: 'cmemployee',
  CMEMPLOYEEDETAILS: 'cmemployee/details',
  CMPROJECT: 'cmproject',
  CMPROJECTDETAILS: 'cmproject/details',
  INVOICEAPPROVEAPPROVELEARNS: 'invoiceapprove/approvelearns',
  INVOICEAPPROVESTATES: 'invoiceapprove/states',
  INVOICEAPPROVEQY: 'invoiceapprove/qy',
  INVOICEAPPROVEAPPLY: 'invoiceapprove/apply',
  INVOICEAPPROVELAST: 'invoiceapprove/last',
  INVOICEAPPROVEGENERATEINVOICECONTRACTCODE: 'invoiceapprove/generateinvoicecontractcode',
  INVOICEAPPROVECONTRACTTEMPLATEDOWNLOAD: 'invoiceapprove/contracttemplate/download',

  BDYTESTMGTBATCHEMPLOYEES: 'bdytestmgt/batch/employees',
  BDYTESTMGTBATCHADDEMPLOYEES: 'bdytestmgt/batch/addemployees',
  BDYTESTMGTBATCHEMPLOYEE: 'bdytestmgt/batch/employee',
  BDYTESTMGTSESSIONSELECT: 'bdytestmgt/session/select',
  BDYTESTMGTBATCHZKZEXPORTINIT: 'bdytestmgt/batch/zkz/export/init',
  BDYTESTMGTBATCHZKZEXPORT: 'bdytestmgt/batch/zkz/export',
  BDYTESTMGTBATCHZKZEXPORTEND: 'bdytestmgt/batch/zkz/export/end',

  EXAMBATCHEMPLOYEES: 'exam/batch/employees',
  EXAMBATCHADDEMPLOYEES: 'exam/batch/addemployees',
  EXAMBATCHEMPLOYEE: 'exam/batch/employee',
  EXAMSESSIONSELECT: 'exam/session/select',
  EXAMBATCHZKZEXPORTINIT: 'exam/batch/zkz/export/init',
  EXAMBATCHZKZEXPORT: 'exam/batch/zkz/export',
  EXAMBATCHZKZEXPORTEND: 'exam/batch/zkz/export/end',

  ENTERPRISEREPORTMODIFY: 'enterprise/reportmodify',
  ENTERPRISEMODIFYAPPROVESTATES: 'enterprise/modifyapprovestates',
  ENTERPRISEMODIFYAPPROVES: 'enterprise/modifyapproves',
  ENTERPRISECONTACT: 'enterprise/contact',
  ENTERPRISEPASSWORD: 'enterprise/password',
  ENTERPRISEEMAIL: 'enterprise/email',
  ENTERPRISEQUALIFICATION: 'enterprise/qualification',

  BDYPRACTICEENROLLADDEMPLOYEES: 'bdypracticeenroll/addemployees',
  BDYPRACTICEENROLL: 'bdypracticeenroll',
  BDYPRACTICEENROLLJFPZ: 'bdypracticeenroll/jfpz',

  ZJYTESTMGTBATCHADDEMPLOYEES: 'zjytestmgt/batch/addemployees',
  ZJYTESTMGTBATCHEMPLOYEES: 'zjytestmgt/batch/employees',

  CERTREPLACECERTOLDSOURCES: 'certreplace/certoldsources',
  CERTREPLACECERTOLDSOURCE: 'certreplace/certoldsource',
  CERTREPLACEENTERPRISECERTREPLACES: 'certreplace/enterprisecertreplaces',
  CERTREPLACEDETAILS: 'certreplace/details',
  CERTREPLACEAPPROVESTATES: 'certreplace/approvestates',
  CERTREPLACE: 'certreplace',

  EMPLOYEECHANGEAPPROVESQ: 'employeechangeapprove/sq',
  EMPLOYEECHANGEAPPROVESH: 'employeechangeapprove/sh',
  EMPLOYEECHANGEAPPROVESHCOUNT: 'employeechangeapprove/shcount',
  EMPLOYEECHANGEAPPROVESTATES: 'employeechangeapprove/states',
  EMPLOYEECHANGEAPPROVEREPORT: 'employeechangeapprove/report',
  EMPLOYEECHANGEAPPROVEAPPROVE: 'employeechangeapprove/approve',
  EMPLOYEECHANGEAPPROVESEARCHEMPLOYEE: 'employeechangeapprove/searchemployee'
};

// 运营
const YYGL = {
  APPROVELLIST: '/enterprise/approvellist',
  ENTERPRISE: '/enterprise',
  ENTERPRISEDETAILS: '/enterprise/details',
  ENTERPRISEREGISTER: '/enterprise/register',
  ENTERPRISEENTERPRISES: '/enterprise/enterprises',
  APPROVE: '/enterprise/approve',
  ENTERPRISEAPPROVE: 'enterprise/enterpriseapprove',
  ENTERPRISELEARNS: 'enterprise/learns',
  ENTERPRISETESTS: 'enterprise/tests',
  ENTERPRISEEMPLOYEES: 'enterprise/employees',
  ENTERPRISEZJYTESTDETAILS: 'enterprise/zjytest/details',
  ENTERPRISEZJYTESTEMPLOYEES: 'enterprise/zjytest/employees',
  ENTERPRISEZJYTESTEMPLOYEERECORD: 'enterprise/zjytest/employee/record',
  ENTERPRISEBDYTESTDETAILS: 'enterprise/bdytest/details',
  ENTERPRISEBDYTESTEMPLOYEES: 'enterprise/bdytest/employees',
  ENTERPRISEBDYTESTEMPLOYEERECORD: 'enterprise/bdytest/employee/record',
  ENTERPRISEUNLOCKLOGIN: 'enterprise/unlocklogin',

  LEARNLEARNAPPROVE: 'learn/learnapprove',
  LEARNLEARNAPPROVECOUNT1: 'learn/learnapprovecount?LearnApproveStateId=1&domain=1',
  LEARNLEARNAPPROVECOUNT2: 'learn/learnapprovecount?LearnApproveStateId=2&domain=1',
  LEARNLEARNAPPROVECOUNT3: 'learn/learnapprovecount?LearnApproveStateId=3&domain=1',
  LEARNJCYLEARNAPPROVECOUNT1: 'learn/learnapprovecount?LearnApproveStateId=1&domain=2',
  LEARNJCYLEARNAPPROVECOUNT2: 'learn/learnapprovecount?LearnApproveStateId=2&domain=2',
  MAKEUPMAKEUPAPPROVECOUNT1: 'makeup/makeupapprovecount?makeUpApproveStateId=1',
  MAKEUPMAKEUPAPPROVECOUNT2: 'makeup/makeupapprovecount?makeUpApproveStateId=2',
  MAKEUPMAKEUPAPPROVECOUNT3: 'makeup/makeupapprovecount?makeUpApproveStateId=3',
  LEARCLOSE: 'learn/close',
  LEARNDELETEEMPLOYEE: '/learn/deleteemployee',
  LEARNENTERPRISE: '/learn/enterprise',
  PENDINGAPPROVALCOUNT: 'enterprise/pendingApprovalCount',
  LEARNINGMGTYY: 'learningmgt/yy',
  LEARNINGMGT: 'learningmgt',
  LEARNINGMGTEMPLOYEE: 'learningmgt/employee',
  LEARNINGMGTEMPLOYEEMOCKEXAMRECORDS: 'learningmgt/employee/mockexamrecords',
  LEARNINGMGTEMPLOYEELESSON: 'learningmgt/employee/lesson',
  LEARNINGMGTEMPLOYEELESSONCATALOGS: 'learningmgt/employee/lessoncatalogs',
  LEARNINGMGTEMPLOYEELESSONALBUMDETAILS: 'learningmgt/employee/lessonalbumdetails',
  LEARNINGMGTEMPLOYEELESSONLOG: 'learningmgt/employee/lesson/log',
  SEARCHEXPORTEMPLOYEE: 'management/searchexportemployee',
  EXPORTEMPLOYEEEXCEL: 'management/exportemployeeexcel',
  EXPORTEMPLOYEEZP: 'management/exportemployeezp',
  EXPORTBDYEXCEL: 'management/exportbdyexcel',
  EXPORTJSGREXCEL: 'management/exportjsgrexcel',
  MAKEUPMAKEUPAPPROVE: 'makeup/makeupapprove',
  MAKEUPMAKEUPKTAPPROVE: 'makeup/makeupktapprove',
  YYHASCOURSE: 'course/yyhascourse',
  LEARNAPPROVEUPDATEINVOICE: 'learn/learnapprove/updateinvoice',
  LEARNUPDATEREGISTERZJY: 'learn/learnapprove/updateregisterzjy',
  LEARNUPDATEEMPLOYEEREGISTERZJY: 'learn/updateemployeeregisterzjy',
  LEARNAPPROVEEXPORTEXCEL: 'learn/learnapprove/exportexcel',
  LEARNAPPROVEEXPORTEMPLOYEEEXCEL: 'learn/learnapprove/exportemployeeexcel',
  LEARNAPPROVEEXPORTBDYEXCEL: 'learn/learnapprove/exportbdyexcel',
  LEARNAPPROVEEXPORTBDYZPZIP: 'learn/learnapprove/exportbdyzpzip',
  LEARNAPPROVEEXPORTBDYHZBEXCEL: 'learn/learnapprove/exportbdyhzbexcel',
  LEARNAPPROVEEXPORTJSGREXCEL: 'learn/learnapprove/exportjsgrexcel',
  LEARNEXPORTBDYBM: 'learn/export/bdybm',
  LEARNEXPORTBDYBMPICINIT: 'learn/export/bdybmpic/init',
  LEARNEXPORTBDYBMPIC: 'learn/export/bdybmpic',
  LEARNEXPORTBDYBMPICEND: 'learn/export/bdybmpic/end',
  MAKEUPAPPROVEUPDATEINVOICE: 'makeup/makeupapprove/updateinvoice',
  MAKEUPAPPROVEEXPORTAPPROVEEXCEL: 'makeup/makeupapprove/exportapproveexcel',
  MAKEUPAPPROVEEXPORTJFAPPROVEEXCEL:
    'makeup/makeupapprove/exportjfapproveexcel',

  TESTMGTROOMS: 'testmgt/rooms',
  TESTMGTROOM: 'testmgt/room',

  TESTMGTBATCHS: 'testmgt/batchs',
  TESTMGTBATCHDETAILS: 'testmgt/batchdetails',
  TESTMGTCOURSEBATCHS: 'testmgt/coursebatchs',
  TESTMGTBATCHEMPLOYEES: 'testmgt/batch/employees',
  TESTMGTBATCHEMPLOYEE: 'testmgt/batch/employee',
  TESTMGTBATCHADDEMPLOYEES: 'testmgt/batch/addemployees',
  TESTMGTBATCHJOBSTATS: 'testmgt/batch/jobstats',
  TESTMGTBATCH: 'testmgt/batch',
  TESTMGTBATCHIMPORTSPBXEXCEL: 'testmgt/batch/importspbxexcel',
  TESTMGTBATCHIMPORTEMPLOYEEEXCEL: 'testmgt/batch/importemployeeexcel',
  TESTMGTBATCHEXPORTEMPLOYEEEXCEL: 'testmgt/batch/exportemployeeexcel',
  TESTMGTBATCHPRACTICEIMPORTANT: 'testmgt/batch/practiceimportant',
  TESTMGTBATCHALLMAKEUP: 'testmgt/batch/allmakeup',

  TESTMGTTRAINS: 'testmgt/trains',
  TESTMGTCOURSETRAINS: 'testmgt/coursetrains',
  TESTMGTTRAINDETAILS: 'testmgt/traindetails',
  TESTMGTTRAINEMPLOYEES: 'testmgt/train/employees',
  TESTMGTTRAIN: 'testmgt/train',
  TESTMGTTRAINEMPLOYEE: 'testmgt/train/employee',
  TESTMGTTRAINALLEMPLOYEES: 'testmgt/train/allemployees',
  TESTMGTTRAINEXPORTEMPLOYEEEXCEL: 'testmgt/train/exportemployeeexcel',
  TESTMGTTRAININITEXPORTEMPLOYEEZP: 'testmgt/train/initexportemployeezp',
  TESTMGTTRAINEXPORTEMPLOYEEZP: 'testmgt/train/exportemployeezp',
  TESTMGTTRAINENDEXPORTEMPLOYEEZP: 'testmgt/train/endexportemployeezp',
  TESTMGTTRAINEXPORTLESSONEXCEL: 'testmgt/train/exportlessonexcel',
  TESTMGTTRAINPRACTICEIMPORTANT: 'testmgt/train/practiceimportant',
  TESTMGTTRAINALLMAKEUP: 'testmgt/train/allmakeup',

  TESTMGTSESSIONSTATES: 'testmgt/sessionStates',
  TESTMGTSESSIONS: 'testmgt/sessions',
  TESTMGTSESSIONDETAILS: 'testmgt/sessiondetails',
  TESTMGTSESSIONEMPLOYEES: 'testmgt/session/employees',
  TESTMGTSESSION: 'testmgt/session',
  TESTMGTSESSIONEMPLOYEEADMISSIONTICKET:
    'testmgt/session/employee/admissionticket',
  TESTMGTSESSIONADDEMPLOYEES: 'testmgt/session/addemployees',
  TESTMGTSESSIONEMPLOYEE: 'testmgt/session/employee',
  TESTMGTSESSIONIMPORTEMPLOYEEEXCEL: 'testmgt/session/importemployeeexcel',
  TESTMGTSESSIONASSIGNSEATNUMBER: 'testmgt/session/assignseatnumber',
  TESTMGTSESSIONINITADMISSIONTICKET: 'testmgt/session/initadmissionticket',
  TESTMGTSESSIONGENERATEADMISSIONTICKET:
    'testmgt/session/generateadmissionticket',
  TESTMGTSESSIONENDADMISSIONTICKET: 'testmgt/session/endadmissionticket',
  TESTMGTSESSIONEXPORTEMPLOYEEEXCEL: 'testmgt/session/exportemployeeexcel',
  TESTMGTSESSIONIMPORTSCOREEXCEL: 'testmgt/session/importscoreexcel',
  TESTMGTSESSIONEXPORTSCOREEXCEL: 'testmgt/session/exportscoreexcel',
  TESTMGTSESSIONEXPORTTESTEXCEL: 'testmgt/session/exporttestexcel',
  TESTMGTSESSIONPRACTICEIMPORTANT: 'testmgt/session/practiceimportant',

  TESTMGTEMPLOYEEPRACTICEIMPORTANT: 'testmgt/employee/practiceimportant',
  TESTMGTZJPXTRAINS: 'testmgt/zjpxtrains',

  ZJYTESTMGTBATCHS: 'zjytestmgt/batchs',
  ZJYTESTMGTBATCHDETAILS: 'zjytestmgt/batchdetails',
  ZJYTESTMGTBATCHEMPLOYEES: 'zjytestmgt/batch/employees',
  ZJYTESTMGTBATCH: 'zjytestmgt/batch',
  ZJYTESTMGTBATCHEMPLOYEE: 'zjytestmgt/batch/employee',
  ZJYTESTMGTBATCHAPPROVEEMPLOYEES: 'zjytestmgt/batch/approve/employees',
  ZJYTESTMGTBATCHAPPROVEEMPLOYEECOUNT:
    'zjytestmgt/batch/approve/employee/count',
  ZJYTESTMGTBATCHEMPLOYEESAPPROVE: 'zjytestmgt/batch/employees/approve',
  ZJYTESTMGTBATCHSCOREIMPORT: 'zjytestmgt/batch/score/import',
  ZJYTESTMGTBATCHEMPLOYEEIMPORT: 'zjytestmgt/batch/employee/import',

  INVOICEAPPROVEYY: 'invoiceapprove/yy',
  INVOICEAPPROVEAPPROVE: 'invoiceapprove/approve',
  INVOICEAPPROVEINVOICE: 'invoiceapprove/invoice',
  INVOICEAPPROVECOUNT: 'invoiceapprove/count',
  INVOICEAPPROVEEXPORTINIT: 'invoiceapprove/export/init',
  INVOICEAPPROVEEXPORTGENERATE: 'invoiceapprove/export/generate',
  INVOICEAPPROVEEXPORTEND: 'invoiceapprove/export/end',

  NEWSCATEGORYS: 'news/categorys',
  NEWSYY: 'news/yy',
  NEWSDETAILS: '/news/details',
  NEWS: 'news',
  NEWSTOP: '/news/top',

  NEWSTESTPLANS: 'newstestplans',
  NEWSTESTPLAN: 'newstestplan',
  NEWSTESTPLANTYPES: 'newstestplantypes',

  EMPLOYEES: '/employee/employees',
  EMPLOYEEDETAILS: '/employee/details',
  EMPLOYEENAME: '/employee/name',
  EMPLOYEEPIC: '/employee/pic',
  EMPLOYEEIDNUMBER: '/employee/idnumber',
  EMPLOYEESEX: '/employee/sex',
  EMPLOYEEENTERPRISE: '/employee/enterprise',
  EMPLOYEERESETPASSWORD: '/employee/resetpassword',
  EMPLOYEEUNBINDOPENID: '/employee/unbindopenid',
  EMPLOYEEUNLOCKLOGIN: '/employee/unlocklogin',
  EMPLOYEEMNKSLEARNS: '/employee/mnkslearns',
  EMPLOYEEMNKSDAYS: '/employee/mnksdays',
  EMPLOYEELEARNS: '/employee/learns',
  EMPLOYEETESTS: '/employee/tests',
  EMPLOYEEPRACTICES: '/employee/practices',

  COURSE: '/course',

  CERT: 'cert',
  CERTCERTS: 'cert/certs',
  CERTCERTSOURCES: 'cert/certsources',
  CERTCERTSTATS: 'cert/certstats',
  CERTDETAILS: 'cert/details',
  CERTEXPORTEXCEL: 'cert/exportexcel',
  CERTEXPORTPDFINIT: 'cert/exportpdf/init',
  CERTEXPORTPDF: 'cert/exportpdf',
  CERTEXPORTPDFEND: 'cert/exportpdf/end',
  CERTSTATE: 'cert/state',

  JSGRTESTMGTBATCHS: 'jsgrtestmgt/batchs',
  JSGRTESTMGTALLBATCHS: 'jsgrtestmgt/allbatchs',
  JSGRTESTMGTBATCH: 'jsgrtestmgt/batch',
  JSGRTESTMGTBATCHJOBSTATS: 'jsgrtestmgt/batch/jobstats',
  JSGRTESTMGTBATCHEMPLOYEES: 'jsgrtestmgt/batch/employees',
  JSGRTESTMGTBATCHEMPLOYEE: 'jsgrtestmgt/batch/employee',
  JSGRTESTMGTBATCHEMPLOYEEIMPORT: 'jsgrtestmgt/batch/employee/import',

  JSGRTESTMGTTRAINS: 'jsgrtestmgt/trains',
  JSGRTESTMGTALLTRAINS: 'jsgrtestmgt/alltrains',
  JSGRTESTMGTTRAINEMPLOYEES: 'jsgrtestmgt/train/employees',
  JSGRTESTMGTTRAIN: 'jsgrtestmgt/train',
  JSGRTESTMGTTRAINALLEMPLOYEES: 'jsgrtestmgt/train/allemployees',
  JSGRTESTMGTTRAINEMPLOYEE: 'jsgrtestmgt/train/employee',
  JSGRTESTMGTTRAINEMPLOYEEEXPORT: 'jsgrtestmgt/train/employee/export',
  JSGRTESTMGTTRAINLESSONEXPORT: 'jsgrtestmgt/train/lesson/export',
  JSGRTESTMGTTRAININITEXPORTEMPLOYEEZP:
    'jsgrtestmgt/train/initexportemployeezp',
  JSGRTESTMGTTRAINEXPORTEMPLOYEEZP: 'jsgrtestmgt/train/exportemployeezp',
  JSGRTESTMGTTRAINENDEXPORTEMPLOYEEZP: 'jsgrtestmgt/train/endexportemployeezp',

  JSGRTESTMGTSESSIONS: 'jsgrtestmgt/sessions',
  JSGRTESTMGTSESSIONDETAILS: 'jsgrtestmgt/session/details',
  JSGRTESTMGTSESSIONEMPLOYEES: 'jsgrtestmgt/session/employees',
  JSGRTESTMGTSESSIONADDEMPLOYEES: 'jsgrtestmgt/session/addemployees',
  JSGRTESTMGTSESSION: 'jsgrtestmgt/session',
  JSGRTESTMGTSESSIONEMPLOYEE: 'jsgrtestmgt/session/employee',
  JSGRTESTMGTSESSIONEMPLOYEEIMPORT: 'jsgrtestmgt/session/employee/import',
  JSGRTESTMGTSESSIONASSIGNSEATNUMBER: 'jsgrtestmgt/session/assignseatnumber',
  JSGRTESTMGTSESSIONINITADMISSIONTICKET:
    'jsgrtestmgt/session/initadmissionticket',
  JSGRTESTMGTSESSIONGENERATEADMISSIONTICKET:
    'jsgrtestmgt/session/generateadmissionticket',
  JSGRTESTMGTSESSIONENDADMISSIONTICKET:
    'jsgrtestmgt/session/endadmissionticket',
  JSGRTESTMGTSESSIONSCOREIMPORT: 'jsgrtestmgt/session/score/import',
  JSGRTESTMGTSESSIONSCOREEXPORT: 'jsgrtestmgt/session/employee/export',

  TESTMGTPLANBATCHS: 'testmgt/planbatchs',
  TESTMGTPLANBATCHJOBSTATS: 'testmgt/planbatch/jobstats',
  TESTMGTPLANBATCHSESSIONS: 'testmgt/planbatch/sessions',
  TESTMGTPLANBATCHSESSION: 'testmgt/planbatch/session',
  TESTMGTPLANBATCH: 'testmgt/planbatch',

  BDYTESTMGTBATCHS: 'bdytestmgt/batchs',
  BDYTESTMGTBATCH: 'bdytestmgt/batch',
  BDYTESTMGTBATCHDETAILS: 'bdytestmgt/batch/details',
  BDYTESTMGTBATCHJOBSTATS: 'bdytestmgt/batch/jobstats',
  BDYTESTMGTBATCHENROLLENABLE: 'bdytestmgt/batch/enroll/enable',
  BDYTESTMGTBATCHSESSIONENABLE: 'bdytestmgt/batch/session/enable',
  // BDYTESTMGTBATCHEGWBMEXPORT: 'bdytestmgt/batch/gwbm/export',
  BDYTESTMGTBATCHEEMPLOYEEEXPORT: 'bdytestmgt/batch/employee/export',
  BDYTESTMGTBATCHPRACTICEIMPORTANT: 'bdytestmgt/batch/practiceimportant',

  BDYTESTMGTSESSIONS: 'bdytestmgt/sessions',
  BDYTESTMGTSESSIONJOBSTATS: 'bdytestmgt/session/jobstats',
  BDYTESTMGTSESSIONDETAILS: 'bdytestmgt/session/details',
  BDYTESTMGTSESSION: 'bdytestmgt/session',
  BDYTESTMGTSESSIONEMPLOYEE: 'bdytestmgt/session/employee',
  BDYTESTMGTSESSIONEMPLOYEES: 'bdytestmgt/session/employees',
  BDYTESTMGTSESSIONEMPLOYEESEATNUMBER: 'bdytestmgt/session/employee/seatnumber',
  BDYTESTMGTSESSIONEMPLOYEEIMPORT: 'bdytestmgt/session/employee/import',
  BDYTESTMGTSESSIONSCOREIMPORT: 'bdytestmgt/session/score/import',
  BDYTESTMGTSESSIONSEATNUMBERASSIGN: 'bdytestmgt/session/seatnumber/assign',
  BDYTESTMGTSESSIONZKZINIT: 'bdytestmgt/session/zkz/init',
  BDYTESTMGTSESSIONZKZGENERATE: 'bdytestmgt/session/zkz/generate',
  BDYTESTMGTSESSIONZKZEND: 'bdytestmgt/session/zkz/end',
  BDYTESTMGTSESSIONKCYBEXPORT: 'bdytestmgt/session/kcyb/export',
  BDYTESTMGTSESSIONEMPLOYEEEXPORT: 'bdytestmgt/session/employee/export',
  BDYTESTMGTSESSIONPRACTICEIMPORTANT: 'bdytestmgt/session/practiceimportant',
  BDYTESTMGTEMPLOYEEPRACTICEIMPORTANT: 'bdytestmgt/employee/practiceimportant',

  EXAMBATCHS: 'exam/batchs',
  EXAMBATCH: 'exam/batch',
  EXAMBATCHCOURSES: 'exam/batch/courses',
  EXAMBATCHDETAILS: 'exam/batch/details',
  EXAMBATCHJOBSTATS: 'exam/batch/jobstats',
  EXAMBATCHENROLLENABLE: 'exam/batch/enroll/enable',
  EXAMBATCHSESSIONENABLE: 'exam/batch/session/enable',
  // EXAMBATCHEGWBMEXPORT: 'exam/batch/gwbm/export',
  EXAMBATCHEEMPLOYEEEXPORT: 'exam/batch/employee/export',
  EXAMBATCHSPBEXPORT: 'exam/batch/spb/export',
  EXAMBATCHPRACTICEIMPORTANT: 'exam/batch/practiceimportant',

  EXAMSESSIONS: 'exam/sessions',
  EXAMSESSIONCOURSES: 'exam/session/courses',
  EXAMSESSIONJOBSTATS: 'exam/session/jobstats',
  EXAMSESSIONDETAILS: 'exam/session/details',
  EXAMSESSION: 'exam/session',
  EXAMSESSIONQDB: 'exam/session/qdb',
  EXAMSESSIONCJB: 'exam/session/cjb',
  EXAMSESSIONRLJLB: 'exam/session/rljlb',
  EXAMSESSIONEMPLOYEE: 'exam/session/employee',
  EXAMSESSIONEMPLOYEES: 'exam/session/employees',
  EXAMSESSIONEMPLOYEESEATNUMBER: 'exam/session/employee/seatnumber',
  EXAMSESSIONEMPLOYEEIMPORT: 'exam/session/employee/import',
  EXAMSESSIONSCORETPLEXPORT: 'exam/session/scoretpl/export',
  EXAMSESSIONSCOREIMPORT: 'exam/session/score/import',
  EXAMSESSIONSEATNUMBERASSIGN: 'exam/session/seatnumber/assign',
  EXAMSESSIONZKZINIT: 'exam/session/zkz/init',
  EXAMSESSIONZKZGENERATE: 'exam/session/zkz/generate',
  EXAMSESSIONZKZEND: 'exam/session/zkz/end',
  EXAMSESSIONKCYBEXPORT: 'exam/session/kcyb/export',
  EXAMSESSIONEMPLOYEEEXPORT: 'exam/session/employee/export',
  EXAMSESSIONPRACTICEIMPORTANT: 'exam/session/practiceimportant',
  EXAMEMPLOYEEPRACTICEIMPORTANT: 'exam/employee/practiceimportant',
  EXAMSESSIONEMPLOYEEOPENCERT: 'exam/session/employee/opencert',
  EXAMBATCHOPENCERT: 'exam/batch/opencert',
  EXAMSESSIONOPENCERT: 'exam/session/opencert',
  EXAMPAPERDETAILS: 'exam/paperdetails',
  EXAMPAPERAPPROVES: 'exam/paperapproves',
  EXAMSESSIONGENERATECERTCODE: 'exam/session/generatecertcode',
  EXAMAPPROVEPAPER: 'exam/approvepaper',
  EXAMBATCHINITAPPROVEPAPER: 'exam/batch/initapprovepaper',
  EXAMSESSIONINITAPPROVEPAPER: 'exam/session/initapprovepaper',

  ENTERPRISEMODIFYAPPROVESYY: 'enterprise/modifyapproves/yy',
  ENTERPRISEPENDINGMODIFYAPPROVALCOUNT: 'enterprise/pendingmodifyapprovalcount',
  ENTERPRISEAPPROVEMODIFY: 'enterprise/approvemodify',

  BDYPRACTICEENROLLS: 'bdypracticeenrolls',
  BDYPRACTICEENROLLAPPROVALCOUNT: 'bdypracticeenrollApprovalCount',
  BDYPRACTICEENROLLSTATES: 'bdypracticeenroll/states',
  BDYPRACTICEENROLLDETAILS: 'bdypracticeenroll/details',
  BDYPRACTICEENROLLAPPROVE: 'bdypracticeenroll/approve',

  QUESTIONQUESTIONS: 'question/questions',
  QUESTIONBDYQUESTIONS: 'question/bdyquestions',

  LEARNINVOICELEARNINVOICES: 'learninvoice/learninvoices',
  LEARNINVOICEGKDKPCOUNT: 'learninvoice/gkdkpcount',
  LEARNINVOICEPXDKPCOUNT: 'learninvoice/pxdkpcount',
  LEARNINVOICEKP: 'learninvoice/kp',
  LEARNINVOICEEXPERTDPWJ: 'learninvoice/expert/dpwj',
  LEARNINVOICEEXPERTDPEXCEL: 'learninvoice/expert/dpexcel',
  LEARNINVOICEDETAILS: 'learninvoice/details',
  LEARNINVOICESTATES: 'learninvoice/states',

  CERTREPLACEAPPROVECERTREPLACES: 'certreplace/approvecertreplaces',
  CERTREPLACEAPPROVES: 'certreplace/approves',
  CERTREPLACEAPPROVECERTREPLACECOUNT1: 'certreplace/approvecertreplacecount1',
  CERTREPLACEAPPROVECERTREPLACECOUNT2: 'certreplace/approvecertreplacecount2',
  CERTREPLACEAPPROVEACTIONS: 'certreplace/approveactions',
  CERTREPLACEAPPROVE: 'certreplace/approve',

  EMPLOYEECHANGEAPPROVEALL: 'employeechangeapprove/all'
};

// 学员管理
const XYGL = {
  MYSTUDY: '/study/mystudy',
  MYSTUDYDETAILS: '/study/mystudydetails',
  MYSTUDYALBUMDETAILS: '/study/mystudyalbumdetails',
  MYSTUDYLESSONDETAILS: '/study/mystudylessondetails',
  UPDATEPROGRESS: '/study/updateprogress',
  COMPLETEPROGRESS: '/study/completeprogress',
  POSTTESTQUESTION: '/study/posttestquestion',
  SUBMITPOSTTEST: '/study/submitposttest',
  COURSEEXAMQUESTION: '/study/courseexamquestion',
  SUBMITCOURSEEXAM: '/study/submitcourseexam',
  STUDYHGKSQUESTION: '/study/hgksquestion',
  STUDYSUBMITHGKS: '/study/submithgks',
  STUDYFACECHECK: '/study/facecheck',
  EMPLOYEEPERSONALPROFILE: 'employee/personalprofile',
  CERTLEARNCERT: 'cert/learncert'
}

export {
    COMMON,
    LOCAL,
    QYGL,
    YYGL,
    XYGL
}



// WEBPACK FOOTER //
// ./src/store/jzjy/constants/funcUrl.js